const calendarEvents = (
  state = {},
  action
) => {
  switch (action.type) {
    case 'FIREBASE_EVENTS_UPDATE_VALUE':
    {
      return Object.assign({}, state, {
        [action.id]: action.value
      })
    }
    default:
      return state
  }
}

export default calendarEvents



// WEBPACK FOOTER //
// ./src/infra/reducers/firebase/calendarEvents.js